enum UserRoleConstants {
  MANAGER = 'MANAGER',
  TECHNICIAN = 'TECHNICIAN',
  TEAM_LEADER = 'TEAM_LEADER',
  OPERATOR = 'OPERATOR',
  SALES_COMPANY_USER = 'SALES_COMPANY_USER',

  // Default value
  UNDEFINED = 'UNDEFINED',
}

export default UserRoleConstants;
